<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Reservation</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <table>
      <tr>
        <td class="pr-3">Name:</td>
        <td>{{ unlinkedReservation.first_name }} {{ unlinkedReservation.last_name }}</td>
      </tr>
      <tr>
        <td class="pr-3">Email Address:</td>
        <td>
          <span *ngIf="unlinkedReservation.email">{{ unlinkedReservation.email }}</span>
          <span *ngIf="!unlinkedReservation.email" class="text-muted">None</span>
        </td>
      </tr>
      <tr>
        <td class="pr-3">Birthday:</td>
        <td>
          <span *ngIf="unlinkedReservation.birthday">{{ dateStringFromISO8601(unlinkedReservation.birthday) }}</span>
          <span *ngIf="!unlinkedReservation.birthday" class="text-muted">None</span>
        </td>
      </tr>
      <tr>
        <td class="pr-3 pt-3">Event:</td>
        <td class="pt-3">{{ unlinkedReservation.event_name }}</td>
      </tr>
      <ng-container *ngFor="let eventPart of unlinkedReservation.event_parts">
        <tr>
          <td></td>
          <td>{{ dateStringFromISO8601(eventPart.start_local_date) }}, {{ eventPart.start_local_time }} - {{ eventPart.end_local_time }}</td>
        </tr>
      </ng-container>
    </table>

    <div class="form-group">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="(selectedCustomer === null) && hasSearchInput()">

      <ng-container *ngIf="hasSearchInput()">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of customerList.results"
                (click)="selectCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="linkInput"
             [value]="UnlinkedReservationAction.link" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="linkInput">
        Link reservation to selected customer
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="createNewInput"
             [value]="UnlinkedReservationAction.createNew" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="createNewInput">
        Create new customer and link to reservation
      </label>
    </div>
    <div class="form-check" *ngIf="showHideOption">
      <input class="form-check-input" type="radio" id="hideInput"
             [value]="UnlinkedReservationAction.hide" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="hideInput">
        Hide from inbox
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>

  </div>

</ng-container>
